export default __webpack_public_path__ + "static/media/banner-mana.1f2fa4c4.jpeg";